import { render, staticRenderFns } from "./BetaCallout.vue?vue&type=template&id=231e5058&scoped=true"
import script from "./BetaCallout.vue?vue&type=script&lang=ts"
export * from "./BetaCallout.vue?vue&type=script&lang=ts"
import style0 from "./BetaCallout.vue?vue&type=style&index=0&id=231e5058&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231e5058",
  null
  
)

export default component.exports